import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChangeAccountSettingsDto } from "@green0meter/api-client";

import {
  GeneralSettingsBox,
  StyledAvatar,
  StyledStack,
  StyledInnerStack,
  StyledTextField,
  StyledEmailField,
  SaveButton,
} from "./GeneralSettings.styled";

import { useUserStore } from "@store/user";
import { useAuth } from "@hooks/useAuth";
import { usersApi } from "@api/services";
import { Error } from "@helpers";
import { Typography } from "@components/base";

const GeneralSettings: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const [newUser, setNewUser] = useState(user);
  const { getUser } = useAuth();

  const handleSave = async (): Promise<void> => {
    if (newUser) {
      const updatedUser: ChangeAccountSettingsDto = {
        email: newUser.email,
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        phoneNumber: newUser.phoneNumber || undefined,
      };

      try {
        await usersApi.usersControllerUpdateUserProfile(updatedUser);
        await getUser();
        alert(t("settings.profileUpdatedSuccessfully"));
      } catch (error) {
        Error("Failed to update user profile", error);
        alert(t("settings.profileUpdateFailed"));
      }
    }
  };

  return (
    <GeneralSettingsBox>
      <Typography variant="h6" gutterBottom>
        {t("settings.generalOverview")}
      </Typography>
      <StyledAvatar>
        {newUser?.firstName?.charAt(0)}
        {newUser?.lastName?.charAt(0)}
      </StyledAvatar>
      <StyledStack spacing={2}>
        <StyledInnerStack direction="row" spacing={5}>
          <StyledTextField
            label={t("settings.firstName")}
            value={newUser?.firstName || ""}
            onChange={(e) => setNewUser({ ...newUser!, firstName: e.target.value })}
            variant="outlined"
          />
          <StyledTextField
            label={t("settings.lastName")}
            value={newUser?.lastName || ""}
            onChange={(e) => setNewUser({ ...newUser!, lastName: e.target.value })}
            variant="outlined"
          />
        </StyledInnerStack>
        <StyledEmailField
          label={t("settings.emailAddress")}
          value={user?.email || ""}
          variant="outlined"
          fullWidth
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
          disabled={true}
        />
      </StyledStack>
      <SaveButton variant="contained" color="success" onClick={handleSave}>
        {t("settings.save")}
      </SaveButton>
    </GeneralSettingsBox>
  );
};

export default GeneralSettings;
